import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { accountingNumberFormatter } from "@common/helpers/number";
import { useGlobalTransactionViewDrawer } from "@components/transactions/TransactionViewDrawer/useGlobalTransactionViewDrawer";
import classNames from "classnames";
import { ChartOfAccountsRow } from "../utils";
import styles from "../styles.module.scss";

export const BalanceCell = memo(
    ({ row }: CellContext<ViewTableFeatures, ChartOfAccountsRow, number>) => {
        const rowData = row.original;
        const openGlobalTransactionViewDrawer =
            useGlobalTransactionViewDrawer();

        // Classification row - no balance
        if (rowData.classification) {
            return <ViewTableCell />;
        }

        if (rowData.group) {
            return (
                <ViewTableCell>
                    <div className={styles.columnContent}>
                        {accountingNumberFormatter(rowData.groupBalance ?? 0)}
                    </div>
                </ViewTableCell>
            );
        }

        // Account row
        if (rowData.account && rowData.entityIds && rowData.accountIds) {
            return (
                <ViewTableCell>
                    <div
                        className={classNames(styles.columnContent, {
                            [styles.balanceColumn]: rowData.account.balance,
                        })}
                        onClick={() => {
                            if (!rowData.account?.balance) {
                                return;
                            }

                            openGlobalTransactionViewDrawer({
                                coaAccounts: rowData.accountIds,
                                entityIds: rowData.entityIds,
                            });
                        }}
                    >
                        {accountingNumberFormatter(rowData.account.balance)}
                    </div>
                </ViewTableCell>
            );
        }

        return <ViewTableCell />;
    },
);
